module.exports = __webpack_public_path__ + "static/media/Platt.d5384069.jpg";